import React from 'react';
import { MarginProps } from '../../../theme/styledProps';
import { RadioBase } from '../Radio/RadioBase/RadioBase';
import {
  VisualPickerWrapper,
  SizeVariant,
  StyledIcon,
  HelperText,
  LabelText,
} from './VisualPicker.styles';
import { Box } from '../Box/Box';
import { Wrapper } from '../Wrapper/Wrapper';
import { CheckboxBase } from '../Checkbox/Checkbox';

export interface VisualPickerProps
  extends Omit<React.ComponentPropsWithoutRef<'input'>, 'size'>,
    MarginProps {
  variant?: 'radio' | 'checkbox';
  label: string;
  helperText?: string;
  checked?: boolean;
  icon?: string;
  rightText?: string;
  rightHelperText?: string;
  sizeVariant?: SizeVariant;
}

export const VisualPicker: React.FC<VisualPickerProps> = ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  children,
  label,
  icon,
  helperText,
  rightText,
  rightHelperText,
  variant = 'radio',
  sizeVariant = 'medium',
  ...rest
}) => {
  const { disabled, checked } = rest;

  const InputComponent = variant === 'radio' ? RadioBase : CheckboxBase;

  return (
    <Wrapper {...rest}>
      <VisualPickerWrapper
        as="label"
        disabled={disabled}
        checked={checked}
        sizeVariant={sizeVariant}
      >
        {icon ? (
          <StyledIcon className={icon} />
        ) : (
          <InputComponent {...rest} checked={disabled ? false : rest.checked} hideFocus />
        )}

        <Box display="flex" flexDirection="column" flex={1} mx="16">
          <LabelText>{label}</LabelText>

          {helperText && <HelperText>{helperText}</HelperText>}
        </Box>

        {rightText && (
          <Box display="flex" flexDirection="column" alignItems="flex-end" mx="16">
            <LabelText>{rightText}</LabelText>

            {rightHelperText && <HelperText>{rightHelperText}</HelperText>}
          </Box>
        )}

        {icon && <InputComponent {...rest} checked={disabled ? false : rest.checked} hideFocus />}
      </VisualPickerWrapper>
    </Wrapper>
  );
};
